import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as logindetails from 'src/assets/js/IFA_Details.js';
import { isNullOrUndefined } from 'util';
@Component({
  selector: 'IFA-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss', './../ifacss.scss']
})
export class FooterComponent implements OnInit {
  CompanyLogo: any;
  Companyemail: any;
  mailtext: any;
  footercontactlink: any;
  footeraddresstext: any;
  footeraddreslink: any;
  footercontacttext: any;
  ARNNo: string = '';
  UploadedQR: any;
  WhatsAppQR: any;
  Googleplaylink: string;
  WhatsAppLink: string;
  FacebookLink: string;
  LinkedInLink: string;
  TwitterLink: string;
  InstagramLink: string;
  AppName: string;
  RegNo: string;
  FromDate: string = '';
  ToDate: string = '';
  constructor(public sanitizer: DomSanitizer) {}

  ngOnInit() {
    let footerinterval = setInterval(() => {
      let i = 0;
      console.log(i++);
      this.Companyemail = this.sanitizer.bypassSecurityTrustResourceUrl(
        sessionStorage.getItem('ihjt45h45=k')
      );
      this.mailtext = sessionStorage.getItem('ihjt45h45=j');
      this.footercontactlink = this.sanitizer.bypassSecurityTrustResourceUrl(
        sessionStorage.getItem('ihjt45h45=l')
      );
      this.footeraddresstext = sessionStorage.getItem('ihjt45h45=n');
      this.footercontacttext = sessionStorage.getItem('ihjt45h45=m');
      this.footeraddreslink = this.sanitizer.bypassSecurityTrustResourceUrl(
        sessionStorage.getItem('ihjt45h45=o')
      );
      this.ARNNo = sessionStorage.getItem('ihjt45h45=q');

      this.CompanyLogo = this.sanitizer.bypassSecurityTrustResourceUrl(
        'data:image/jpg;base64,' + sessionStorage.getItem('lkighty445dh==')
      );
      let UploadedQR = this.sanitizer.bypassSecurityTrustResourceUrl(
        'data:image/jpg;base64,' + sessionStorage.getItem('lkighty445dh==QR')
      );
      let WhatsAppQR = this.sanitizer.bypassSecurityTrustResourceUrl(
        'data:image/jpg;base64,' +
          sessionStorage.getItem('lkighty445dh==WhatsAppQR')
      );
      let playLink = sessionStorage.getItem('ihjt45h45=t');
      let WhatsAppLink = sessionStorage.getItem('lkighty445dh==WhatsAppLink');
      let FacebookLink = sessionStorage.getItem('lkighty445dh==FacebookLink');
      let LinkedInLink = sessionStorage.getItem('lkighty445dh==LinkedInLink');
      let TwitterLink = sessionStorage.getItem('lkighty445dh==TwitterLink');
      let InstagramLink = sessionStorage.getItem('lkighty445dh==InstagramLink');
      this.AppName = !isNullOrUndefined(
        sessionStorage.getItem('lkighty445dh==AppName')
      )
        ? sessionStorage.getItem('lkighty445dh==AppName')
        : '';
      this.RegNo = !isNullOrUndefined(
        sessionStorage.getItem('lkighty445dh==RegNo')
      )
        ? sessionStorage.getItem('lkighty445dh==RegNo')
        : '';
      this.FromDate = !isNullOrUndefined(
        sessionStorage.getItem('lkighty445dh==FromDate')
      )
        ? sessionStorage.getItem('lkighty445dh==FromDate')
        : '';
      this.ToDate = !isNullOrUndefined(
        sessionStorage.getItem('lkighty445dh==ToDate')
      )
        ? sessionStorage.getItem('lkighty445dh==ToDate')
        : '';

      if (
        UploadedQR !== undefined &&
        UploadedQR !== null &&
        UploadedQR !== '' &&
        UploadedQR !== 'null'
      ) {
        this.UploadedQR = UploadedQR;
      }
      if (
        WhatsAppQR !== undefined &&
        WhatsAppQR !== null &&
        WhatsAppQR !== '' &&
        WhatsAppQR !== 'null'
      ) {
        this.WhatsAppQR = WhatsAppQR;
      }
      if (
        playLink !== undefined &&
        playLink !== null &&
        playLink !== '' &&
        playLink !== 'null'
      ) {
        this.Googleplaylink = playLink;
      }
      if (
        WhatsAppLink !== undefined &&
        WhatsAppLink !== null &&
        WhatsAppLink !== '' &&
        WhatsAppLink !== 'null'
      ) {
        this.WhatsAppLink = WhatsAppLink;
      }
      if (
        FacebookLink !== undefined &&
        FacebookLink !== null &&
        FacebookLink !== '' &&
        FacebookLink !== 'null'
      ) {
        this.FacebookLink = FacebookLink;
      }
      if (
        LinkedInLink !== undefined &&
        LinkedInLink !== null &&
        LinkedInLink !== '' &&
        LinkedInLink !== 'null'
      ) {
        this.LinkedInLink = LinkedInLink;
      }
      if (
        TwitterLink !== undefined &&
        TwitterLink !== null &&
        TwitterLink !== '' &&
        TwitterLink !== 'null'
      ) {
        this.TwitterLink = TwitterLink;
      }
      if (
        InstagramLink !== undefined &&
        InstagramLink !== null &&
        InstagramLink !== '' &&
        InstagramLink !== 'null'
      ) {
        this.InstagramLink = InstagramLink;
        clearInterval(footerinterval);
        console.log('Closing footerInterval');
      }
    }, 1000);
  }
}
